<template>
    <div id="contenedor-catalogos-default">
      <router-view />
    </div>
</template>

<script>
export default {
  name: 'CatalogosDefault',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
